export const clubInfo = {
  name: "Hundesportverein Berlin-Adlershof e.V.",
  shortName: "HSV Adlershof",
  founded: 1948,
  logo: "/images/common/HSV_Logo.jpg",
  contact: {
    address: "Birkenweg, 12439 Berlin",
    email: "hsv.berlin.adlershof@gmail.com",
    phone: "0162 / 2068729",
    contactPerson: "Toni Meier (1. Vorsitzender)"
  },
  tagline: "Stärken Sie die Bindung zu Ihrem Hund – mitten in Berlin-Treptow"
};

export const navigation = [
  { id: 'home', label: 'Startseite', path: '/' },
  { id: 'sports', label: 'Sportarten', path: '/trainings' },
  { id: 'club', label: 'Verein', path: '/about' },
  { id: 'events', label: 'Termine', path: '/termine' },
  { id: 'rules', label: 'Platzordnung', path: '/platzordnung' },
  { id: 'contact', label: 'Kontakt', path: '/kontakt' }
];

export const trainingSports = [
  {
    id: 'obedience',
    title: 'Unterordnung',
    subtitle: 'Fördert Gehorsam und Teamarbeit',
    description: 'Die Unterordnung konzentriert sich auf grundlegende Kommandos und fördert die Zusammenarbeit zwischen Mensch und Hund. Geeignet für alle Hunderassen.',
    path: '/unterordnung',
    image: '/images/sports/obedience/companion-dog.jpg'
  },
  {
    id: 'rally-obedience',
    title: 'Rallye Obedience',
    subtitle: 'Kreatives Training in Teamarbeit',
    description: 'Rallye Obedience kombiniert Gehorsamsübungen mit einem Parcours. Es fördert die Kommunikation und macht Spaß für alle Erfahrungsstufen.',
    path: '/sport/rally-obedience',
    image: '/images/sports/rally-obedience/rally-demo.jpg'
  },
  {
    id: 'tournament',
    title: 'Turnierhundesport',
    subtitle: 'Wettbewerbsorientiertes Training',
    description: 'Der Turnierhundesport (THS) betont Geschicklichkeit und Präzision im Wettkampf. Perfekt für sportlich ambitionierte Teams.',
    path: '/sport/turnierhundesport',
    image: '/images/sports/ths/ths-training.jpg'
  },
  {
    id: 'agility',
    title: 'Agility',
    subtitle: 'Fördert schnelle Beweglichkeit',
    description: 'Agility ist ein dynamischer Sport mit Hindernisparcours. Spaß für aktive Hunde und ihre Besitzer!',
    path: '/sport/agility',
    image: '/images/sports/agility/agility-course.jpg'
  }
];

export const events2025 = [
  {
    id: 1,
    title: 'Ostersuche',
    date: '21. April 2025',
    description: 'Traditionelle Ostersuche für Hunde und ihre Besitzer'
  },
  {
    id: 2,
    title: 'Sommerfest',
    date: '19. Juli 2025',
    description: 'Unser jährliches Sommerfest mit Spielen und Aktivitäten'
  },
  {
    id: 3,
    title: 'Kossepokal',
    date: '14. September 2025',
    description: 'Wettkampfturnier für alle Sportarten'
  },
  {
    id: 4,
    title: 'Prüfungen',
    date: '28. September 2025',
    description: 'Offizielle Prüfungen in allen Disziplinen'
  },
  {
    id: 5,
    title: 'Weihnachtsfeier',
    date: '13. Dezember 2025',
    description: 'Gemütlicher Jahresausklang mit der Vereinsfamilie'
  }
];

export const clubHistory = [
  {
    year: 1948,
    event: 'Gründung als Sektion "Dienst- und Gebrauchshunde"'
  },
  {
    year: 1952,
    event: 'Erster Hindernisparcours eingerichtet'
  },
  {
    year: 1990,
    event: 'Offizielle Vereinsgründung'
  },
  {
    year: 1992,
    event: 'Umbenennung in heutigen Namen'
  },
  {
    year: 2006,
    event: 'Anerkennung durch Senatssportverwaltung'
  }
];

export const leadership = [
  {
    name: 'Toni Meier',
    position: '1. Vorsitzender',
    email: 'hsv.berlin.adlershof@gmail.com',
    image: '/images/team/toni.jpg',
    description: 'Leitet jeden Samstag das Training für Gäste und Mitglieder. Über 10 Jahre im Verein tätig und spezialisiert auf Basis, IBgH, Agility und THS.'
  },
  {
    name: 'Denise Broscheit',
    position: '2. Vorsitzende',
    image: '/images/team/denise.jpg',
    description: 'Seit 2 Jahren im Verein engagiert. Trainerin für Basisarbeit mit 4 Hunden, von denen einer bereits die BH bestanden hat.'
  },
  {
    name: 'Stefanie Markstein',
    position: 'Schriftführerin',
    image: '/images/team/Stefanie.jpg',
    description: 'Seit 2024 im Verein. Mit ihrer Hündin erfolgreich BH bestanden.'
  },
  {
    name: 'Markus Tietke',
    position: 'Kassenwart',
    image: '/images/team/markus.jpg',
    description: 'Verwaltet die Vereinsfinanzen mit großer Sorgfalt. Aktiv im Hundesport seit 5 Jahren mit seinem Chihuahua – Lucky.'
  }
];

export const faqData = [
  {
    question: 'Was muss ich zum ersten Besuch mitbringen?',
    answer: `Für den ersten Besuch bringe bitte Folgendes mit:
• Impfpass des Hundes mit einem gültigen Nachweis über die Tollwutimpfung
• Nachweis über eine Tierhalterhaftpflichtversicherung (Hundehalterhaftpflicht)
• Halsband oder Brustgeschirr und Leine (bitte keine Flexileinen, Länge nicht länger als 2 Meter)
• Viele kleine und weiche Leckerlis für Ihren Hund – je mehr, desto besser!
• Optional: Eine Decke oder ein Kissen für Ihren Hund, damit er sich bequem hinlegen kann

Wir freuen uns darauf, dich und deinen Hund kennenzulernen!`
  },
  {
    question: 'Was kostet das Gästetraining?',
    answer: `Das erste Gästetraining ist kostenfrei. Anschließend bieten wir zwei Gästekarten an:
• 5er-Karte für 50 €
• 10er-Karte für 90 €`
  },
  {
    question: 'Wie lange läuft die Gästephase?',
    answer: 'Die Gästephase dauert mindestens bis zur nächsten Mitgliederversammlung, bei der über deinen Aufnahmeantrag abgestimmt wird. Mitgliederversammlungen finden in der Regel im Frühjahr und im Herbst statt. Bis zur Entscheidung bleibst du in der Gästephase.'
  },
  {
    question: 'Wie komme ich auf die Warteliste?',
    answer: `Unsere Samstags-Gästegruppe ist aktuell ausgebucht. Du kannst dich aber jederzeit über das Kontaktformular für die Warteliste anmelden.

Bitte gib in deiner Nachricht kurz an:
• Erfahrung mit deinem Hund (Anfänger / Fortgeschrittene)
• Gewünschte Sportart (Unterordnung, Rally Obedience, Turnierhundesport)
• Alter und Rasse deines Hundes

Sobald ein Platz frei wird, melden wir uns bei dir. Bitte hab Verständnis dafür, dass die Wartezeit variieren kann.`
  }
];